export function getReqVerificationToken (context: Document = document): string | null {
	const cssSelector = '[name=\'__RequestVerificationToken\']';

	const input: HTMLInputElement = context.querySelectorAll(cssSelector)[0] as HTMLInputElement;
	if (input) {
		return input.value;
	}

	return null;
}

export function getReqVerificationTokenHeaderKey (): string {
	return 'X-CSRF-TOKEN';
}
